
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import PropTypes from 'prop-types';
import InfoModal from '@components/InfoModal';
import Button from '@/src/components/Button';
import Image from '@components/Image';
import Logo from '@components/Logo';
import DownloadPortrait from '@components/DownloadPortrait';
import { useUserContext } from '@contexts/user-context';
import { getGlobalState } from '@states/ProfileState';
import { HASHTAG_FALLBACK } from '@constants/avatar-maker';
import s from './ShareYourPortrait.module.scss';
const propTypes = {
    onCloseModal: PropTypes.func.isRequired
};
const ShareYourPortrait = ({ onCloseModal }) => {
    const avatarImage = getGlobalState('userAvatarImage');
    const { profile } = useUserContext();
    const house = profile?.hogwartsHouse?.toLowerCase() || 'nohouse';
    const hashtag = process.env.REACT_APP_AVATAR_SHARE_PORTRAIT_HASHTAG || HASHTAG_FALLBACK;
    return (<InfoModal isOpen toggleModal={onCloseModal} className={s.shareAvatarModal} secondaryCloseBtn closeBtnColor="#FFF" autoSize>
      <div className={[s.modalContent, s[house]].join(' ')}>
        <div className={s.shareModalContainer}>
          <DownloadPortrait>
            <Button type="secondary" label="Download" onClick={() => onCloseModal()} data-testid="mobileDownloadBtn" className={s.downloadButtonMobile}/>
          </DownloadPortrait>

          <Image imageSet={[{ src: avatarImage }]} className={s.avatarImage} alt="Portrait image"/>
          <div className={s.textContainer}>
            <div className={s.logoContainer}>
              <Logo />
            </div>
            <div className={s.shareTitle}>Share Your Portrait</div>
            <div className={s.hashTagText}>{`Use the hashtag ${hashtag}`}</div>
            <DownloadPortrait>
              <Button type="secondary" label="Download" onClick={() => onCloseModal()} data-testid="desktopDownloadBtn" className={s.downloadButtonDesktop}/>
            </DownloadPortrait>
          </div>
        </div>
      </div>
    </InfoModal>);
};
ShareYourPortrait.propTypes = propTypes;
export default ShareYourPortrait;

    async function __Next_Translate__getStaticProps__195ca0f59c3__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//Profile/components/UserPanel/ShareYourPortrait/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0f59c3__ as getStaticProps }
  